module.exports = __webpack_public_path__ + "img/Ilustracion Modal Bienvenida.2a3f791e.svg";